const fixSteve = ele =>
  ele.name !== "steve"
    ? atob(ele.svg)
    : atob(ele.svg)
        .replace(/width/i, "")
        .replace(/height/i, "");

export default fixSteve;



// WEBPACK FOOTER //
// ./src/fixSteve.js